import {runInIdleTime} from '@vio/core/src/_web/utils/performance/idleUntilUrgent'
import {dataDogLogEvent} from '@vio/core/src/analytics/components/DataDogClient'
import {experimentVariationsStore} from '@vio/core/src/experiments/components/OpticksProvider'

import {getFullStorySessionUrl} from './getFullStorySessionUrl'

export const logEvent = (
  event: string,
  metadata: Record<string, unknown> = {},
  level?: 'error' | 'info' | 'debug' | 'warn',
  eventPrefix?: 'Search' | 'BookingManagement'
) => {
  const log = () => {
    const dataDogEnabled = Boolean(process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN)
    if (!dataDogEnabled) return

    const experiments = experimentVariationsStore.getAll(true)
    const fsSessionUrl = getFullStorySessionUrl()

    dataDogLogEvent(
      `${eventPrefix || 'Search'}.${event}`,
      {
        ...metadata,
        experiments,
        fsSessionUrl
      },
      level
    )
  }

  runInIdleTime(log)
}
